<template>
  <Layout>
    <SectionTop></SectionTop>
    <SectionManage></SectionManage>
    <SectionIndustry></SectionIndustry>
    <SectionIncome></SectionIncome>
    <SectionFeatures></SectionFeatures>

    <DingBeautyFunctions :functionList="functionList"></DingBeautyFunctions>
    <br class="mobile-only" />
    <DingBeautyPlans
      :title="
        `<p class='dingbeauty-sub-title fancy-title'>Pricing</p>
    <h2 class='dingbeauty-title is-dotted is-small'>Ding Beauty <br class='mobile-only' />愛美訂價格方案</h2>
    <p class='plans-title--small'
      >拿出您的現有電腦，立即開始輕鬆管理！<br />我們提供多種使用方案，讓店家能多元選擇，<br />不管是個人工作室還是多店連鎖品牌，<br />愛美訂都能提供您最合適的系統方案！</p
    >
    <p class='plans-title--small'>從最初引進系統使用開始，到未來出現任何問題，愛美訂都會在這裡為您服務</p>`
      "
    ></DingBeautyPlans>
    <SectionAdvantage></SectionAdvantage>
    <SectionContact></SectionContact>
  </Layout>
</template>

<script>
import Layout from '@layout/main'
import SectionTop from './components/SectionTop'
import SectionManage from './components/SectionManage'
import SectionIndustry from './components/SectionIndustry'
import SectionIncome from './components/SectionIncome'
import SectionFeatures from './components/SectionFeatures'
import DingBeautyFunctions from '@components/DingBeauty/DingBeautyFunctions.vue'
import DingBeautyPlans from '@components/DingBeauty/DingBeautyPlans.vue'
import SectionAdvantage from './components/SectionAdvantage'
import SectionContact from './components/SectionContact.vue'

export default {
  components: {
    Layout,
    SectionTop,
    SectionManage,
    SectionIndustry,
    SectionIncome,
    SectionFeatures,
    DingBeautyFunctions,
    DingBeautyPlans,
    SectionAdvantage,
    SectionContact,
  },

  data() {
    return {
      functionList: [
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_01.svg'),
          title: '指定美容師<br class="only-mobile">/服務人員',
          subTitle: '為美業打造的指定服務人員功能，不只輕鬆指定，還可為服務人員設定價格，讓客戶享受個人化體驗',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_02.svg'),
          title: '服務人員管理',
          subTitle: '明確設定每位服務人員的服務範疇，提供精準服務',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_03.svg'),
          title: '行銷整合',
          subTitle: '多元化的行銷方式，包括：優惠券、儲值金、數據分析等，讓您輕鬆制訂行銷策略',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_04.svg'),
          title: '服務變價設定',
          subTitle: '隨時可為訂單加購服務、變價調整，滿足客戶需求，增加價格彈性，讓您為客戶客製專屬服務',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_05.svg'),
          title: '空間管理',
          subTitle: '自由管理各分店空間與人員的分配，最大化您的店面使用效率',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_06.svg'),
          title: '分店管理',
          subTitle: '多家分店可獨立設定店家資訊， 讓客戶輕鬆選擇最方便的分店，提升客戶體驗',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_07.svg'),
          title: '預約通知',
          subTitle: '自動發送預約通知，簡訊、Line、Email通通搞定，為您省去繁複的聯繫提醒，有效降低客戶缺席狀況',
        },
        {
          img: require('@assets/dingbeauty-images/home/functions/icon_08.svg'),
          title: 'Line官方帳號預約',
          subTitle: '客戶可以輕鬆透過Line預約服務，也能輕鬆查詢包月和儲值狀態，提高預約便捷性',
        },
      ],
    }
  },
}
</script>
